export enum trackedQuizActions {
  Tracking_SubmitQuiz = 'Tracking_SubmitQuiz',
}

export const submitQuizResults = (quizId: string, score: number, passingScore: number | null) => ({
  type: trackedQuizActions.Tracking_SubmitQuiz,
  payload: {
    quizId,
    score,
    passingScore,
  },
});
